import {
  addAdditionalContactCard,
  agentCard,
  appraiserContactCard,
  attorneyContactCard,
  counterpartyAgentCard,
  counterpartyTCCard,
  homeWarrantyContactCard,
  leadSourceCard,
  lenderContactCard,
  listingPriceCard,
  notesCard,
  otherContactCard,
  propertyBeingSoldCard,
  salesPriceCard,
} from '../shared';
import type { DefaultCoverSheetConfig, LocaleOverrides } from '../types';
import {
  buyerCard,
  commissionDetailsCard,
  importantDatesCard,
  mlsInformationCard,
  propertyDetailsCard,
  sellerCard,
  titleOfficerContactCard,
} from './cards';

export const BaseListingConfig = {
  version: '1',
  sections: {
    propertyInfo: {
      id: 'propertyInfo',
      header: 'Property Info',
      sidebarText: 'Property Info',
      cards: {
        propertyBeingSoldCard,
        propertyDetailsCard,
        importantDatesCard,
        mlsInformationCard,
        listingPriceCard,
        commissionDetailsCard,
        salesPriceCard,
        notesCard,
      },
    },
    sellerSideContacts: {
      id: 'sellerSideContacts',
      header: "Seller's Contacts",
      sidebarText: 'Seller Contacts',
      cards: {
        sellersAgentCard: {
          ...agentCard,
          id: 'sellerSideContacts.sellersAgent',
          innerTitle: "Seller's Agent x",
          outerTitle: "Seller's Agents",
          addableTitle: "Seller's Agent x",
          addText: "Seller's Agent",
        },
        sellerCard,
        leadSourceCard,
      },
    },
    buyerSideContacts: {
      id: 'buySideContacts',
      header: "Buyer's Contacts",
      sidebarText: 'Buyer Contacts',
      cards: {
        buyersAgentCard: {
          ...counterpartyAgentCard,
          id: 'buySideContacts.buyersAgent',
          innerTitle: "Buyer's Agent x",
          outerTitle: "Buyer's Agents",
          addText: "Buyer's Agent",
          addableTitle: "Buyer's Agent x",
        },
        buyerTCCard: {
          ...counterpartyTCCard,
          id: 'buySideContacts.buyersTC',
          innerTitle: "Buyer's Transaction Coordinator",
          outerTitle: "Buyer's Transaction Coordinators",
          addableTitle: "Buyer's Transaction Coordinator",
        },
        buyerCard,
      },
    },
    additionalContacts: {
      id: 'additionalContacts',
      header: 'Additional Contacts',
      sidebarText: 'Additional Contacts',
      cards: {
        titleOfficerContactCard,
        lenderContactCard,
        appraiserContactCard,
        attorneyContactCard,
        homeWarrantyContactCard,
        otherContactCard,
        addAdditionalContactCard,
      },
    },
  },
} satisfies DefaultCoverSheetConfig;

export type ListingLocaleOverrides = LocaleOverrides<typeof BaseListingConfig>;
